import React from 'react';
import { Card, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { InvoiceDetailsTable } from '@components/Billing/Invoices/Details/DetailsTable';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page404, Page500 } from '@containers/ErrorPages';
import { billingApi } from '@reducers/billing';

export const Details = () => {
  const { uuid } = useParams();
  const { data, isLoading, isFetching, isError } =
    billingApi.useGetInvoiceDetailsQuery({
      uuid,
    });

  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  if (!data) {
    return <Page404 />;
  }

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Invoice details</Card.Header>
      <Card.Body>
        <Col md={6}>
          <InvoiceDetailsTable data={[data]} />
        </Col>
      </Card.Body>
    </Card>
  );
};
